

/* ===========================================================
   override functions api.jquery.js
   =========================================================== */

Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.cart-item-loop');
};

function updateCartCountText(cart) {
  var el = document.querySelector('.cart-count-text');
  if (!el) return;

  var singular = el.getAttribute('data-singular');
  var plural   = el.getAttribute('data-plural');

  var template = cart.item_count === 1 ? singular : plural;
  if (!template) return;

  el.textContent = template.replace('%count%', cart.item_count);
}

Shopify.cartUpdateInfo = function (cart, cart_cell_id) {
  var cart_cell = jQuery(cart_cell_id);
  if (!cart_cell.length) return;

  // Clear existing cart entries
  cart_cell.empty();

  var items = cart.items;

  if (items.length) {
    jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area").css({ display: "block" });
    jQuery(".cart-empty-title").css({ display: "none" });

    jQuery.each(items, function (i, item) {
      if (i > 19) return false;

      var isSubscription = !!item.selling_plan_allocation;

      // Build quantity input
      var qtyInput = isSubscription
        ? '<input value="' + item.quantity + '" type="text" class="qt is-locked" readonly>'
        : '<input value="' + item.quantity + '" type="text" name="quantity" class="qt" min="1" pattern="[0-9]*">';

      // Build cart row HTML
      var rowHtml =
        '<li class="cart-item" data-line="' + (i + 1) + '" data-unit-price="' + item.price + '">' +

          '<div class="cart-image">' +
            '<a href="' + item.url + '">' +
              '<img src="' + item.image + '" alt="' + (item.alt || "") + '" class="img-fluid" loading="lazy">' +
            '</a>' +
          '</div>' +

          '<div class="cart-title">' +
            '<a href="' + item.url + '">' + item.title.substring(0, 50) + '</a>' +
            (isSubscription ? '<span class="sub-badge">Subscription</span>' : '') +   // ⭐ Subscription Badge

            '<div class="cart-pro-info">' +

              '<div class="cart-qty-price">' +
                '<span class="quantity-' + item.id + '">' + item.quantity + '</span> × ' +
                '<span class="price-box"><span class="new-price">' +
                  Shopify.formatMoney(item.price) +
                '</span></span>' +
              '</div>' +

              '<div class="product-quantity-action">' +
                '<div class="product-quantity" data-variant="' + item.id + '">' +
                  '<div class="cart-plus-minus ' + (isSubscription ? 'is-locked' : '') + '">' +
                    '<div class="dec qtybutton">-</div>' +
                      qtyInput +
                    '<div class="inc qtybutton">+</div>' +
                  '</div>' +
                '</div>' +

                '<div class="delete-item-cart">' +
 '<a class="remove_from_cart" href="#" data-remove-line="' + (i + 1) + '">' +
                    '<i class="feather-trash-2"></i>' +
                  '</a>' +
                '</div>' +

              '</div>' + // /product-quantity-action
            '</div>' + // /cart-pro-info

          '</div>' + // /cart-title
        '</li>';

      cart_cell.append(rowHtml);
    });

  } else {
    jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area").css({ display: "none" });
    jQuery(".cart-empty-title").css({ display: "block" });
  }

  // Update totals
  jQuery(".subtotal-price").html(Shopify.formatMoney(cart.total_price));
  jQuery(".bigcounter").html(cart.item_count);

  updateCartCountText(cart);

  // Currency switcher (if used)
  jQuery('.currency .active').trigger('click');
};

/* Utility */
function changeHtmlValue(cell, value) {
  jQuery(cell).html(value);
}
